(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_a3ebafa"] && !Shopify.designMode) return;
  try {
    (function () {
    function isExcludedDay(date, noSaturday, noSunday) {
      var day = date.getDay();
      return (day === 6 && noSaturday) || (day === 0 && noSunday);
    }

    function addDeliveryDays(startDate, days, noSaturday, noSunday) {
      var result = new Date(startDate);
      var added = 0;
      while (added < days) {
        result.setDate(result.getDate() + 1);
        if (!isExcludedDay(result, noSaturday, noSunday)) {
          added++;
        }
      }
      return result;
    }

    function formatRange(minDate, maxDate, locale) {
      try {
        var dayFmt = new Intl.DateTimeFormat(locale, { day: 'numeric' });
        var monthFmt = new Intl.DateTimeFormat(locale, { month: 'long' });
        var minDay = dayFmt.format(minDate);
        var maxDay = dayFmt.format(maxDate);
        var minMonth = monthFmt.format(minDate);
        var maxMonth = monthFmt.format(maxDate);

        if (minDate.getFullYear() === maxDate.getFullYear()) {
          if (minMonth === maxMonth) {
            return minDay + '\u2013' + maxDay + ' ' + maxMonth;
          }
          return minDay + ' ' + minMonth + ' \u2013 ' + maxDay + ' ' + maxMonth;
        }

        var yearFmt = new Intl.DateTimeFormat(locale, { year: 'numeric' });
        return (
          minDay + ' ' + minMonth + ' ' + yearFmt.format(minDate) +
          ' \u2013 ' +
          maxDay + ' ' + maxMonth + ' ' + yearFmt.format(maxDate)
        );
      } catch (e) {
        return '';
      }
    }

    function initAIStockDisplay(container) {
      var dateEls = container.querySelectorAll('[data-ai-stock-date]');
      if (!dateEls.length) return;

      var minDays = parseInt(container.dataset.minDays, 10) || 0;
      var maxDays = parseInt(container.dataset.maxDays, 10) || 0;
      var cutoffHour = parseInt(container.dataset.cutoffHour, 10) || 0;
      var noSaturday = container.dataset.noSaturday === 'true';
      var noSunday = container.dataset.noSunday === 'true';

      var now = new Date();
      var startDate = new Date(now);
      if (now.getHours() >= cutoffHour) {
        startDate.setDate(startDate.getDate() + 1);
      }

      var minDate = addDeliveryDays(startDate, minDays, noSaturday, noSunday);
      var maxDate = addDeliveryDays(startDate, Math.max(maxDays, minDays), noSaturday, noSunday);

      var locale = container.dataset.locale || document.documentElement.lang || 'fr';
      var rangeText = formatRange(minDate, maxDate, locale);

      dateEls.forEach(function (el) {
        el.textContent = rangeText;
      });
    }

    function initAllAIStockDisplays(root) {
      var scope = root || document;
      scope.querySelectorAll('[data-ai-stock-display]').forEach(function (container) {
        initAIStockDisplay(container);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAllAIStockDisplays(document);
      });
    } else {
      initAllAIStockDisplays(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAllAIStockDisplays(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
